// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_conv_pane__more_actions__-fTyQ.ant-dropdown {\n  z-index: var(--zindex-layer-09);\n}\n", "",{"version":3,"sources":["webpack://./src/components/organisms/projects/project-conversation/conversation-components/conversation-pane/styles.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC","sourcesContent":[".conv_pane__more_actions:global(.ant-dropdown) {\n  z-index: var(--zindex-layer-09);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"conv_pane__more_actions": "styles_conv_pane__more_actions__-fTyQ"
};
export default ___CSS_LOADER_EXPORT___;
